import { HotmartRum } from "@commons/observability"
import {
    ComponentErrorInterface,
    ComponentInfoInterface
} from "../../../realms/types/componentError.interface"
import { ErrorBase } from "./errorBase"

class ComponentError extends ErrorBase {
    constructor(errorData: ComponentErrorInterface) {
        super(errorData.error.message)
        this.name = "ComponentError"

        this.clearStacktrace()

        this.captureError({
            componentName: errorData.componentName,
            componentProperties: errorData.componentProperties
        })
    }

    private captureError(componentInfo: ComponentInfoInterface) {
        HotmartRum.captureException(this, {
            extra: { componentInfo }
        })
    }
}

export default ComponentError
